export default __webpack_public_path__ + "static/media/vanessa.4b2765b1.png";